var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircledPlayButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 22,
    cy: 22,
    r: 22,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.0003V30.0003C15.9999 30.1782 16.0474 30.3529 16.1374 30.5064C16.2274 30.6599 16.3567 30.7866 16.512 30.8734C16.6673 30.9602 16.843 31.0041 17.0209 31.0003C17.1988 30.9966 17.3725 30.9455 17.524 30.8523L30.524 22.8523C30.6696 22.7628 30.7898 22.6375 30.8733 22.4884C30.9567 22.3392 31.0005 22.1712 31.0005 22.0003C31.0005 21.8294 30.9567 21.6613 30.8733 21.5122C30.7898 21.363 30.6696 21.2378 30.524 21.1483L17.524 13.1483C17.3725 13.055 17.1988 13.0039 17.0209 13.0002C16.843 12.9965 16.6673 13.0403 16.512 13.1271C16.3567 13.214 16.2274 13.3407 16.1374 13.4941C16.0474 13.6476 15.9999 13.8224 16 14.0003Z",
    fill: "#007A9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircledPlayButton);
export default __webpack_public_path__ + "static/media/CircledPlayButton.86c9161e.svg";
export { ForwardRef as ReactComponent };